var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path0, _g6, _path1, _g7, _path10, _path11, _g8, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageSip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 78,
    viewBox: "0 0 65 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5073 80.0015H6.30697C2.88956 80.0015 0.109375 77.2324 0.109375 73.8287V24.0738C0.109375 18.5388 3.06663 13.5022 7.87116 10.7788V4.78125H56.9431V10.7788C61.7473 13.5022 64.7049 18.5392 64.7049 24.0738V73.8287C64.7049 77.2324 61.9247 80.0015 58.5073 80.0015ZM9.97073 6.87243V12.038L9.40245 12.3301C4.96535 14.6098 2.2093 19.1097 2.2093 24.0738V73.8287C2.2093 76.0791 4.04748 77.9103 6.30697 77.9103H58.5073C60.7668 77.9103 62.6054 76.0791 62.6054 73.8287V24.0738C62.6054 19.1097 59.849 14.6098 55.4119 12.3301L54.8436 12.038V6.87243H9.97073Z",
    fill: "#6B86F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8274 0H5.64062V8.70769H58.8274V0Z",
    fill: "#2847C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4182 0H10.5234V8.71327H36.4182V0Z",
    fill: "#1C359F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3741 0H43.0781V8.70769H53.3741V0Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14304_101293)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 53,
    width: 25,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5248 53H53.4908C54.2984 53 54.9531 53.6721 54.9531 54.5013V58.5225C54.9531 59.3517 54.2984 60.0238 53.4908 60.0238H31.5248C30.7172 60.0238 30.0625 59.3517 30.0625 58.5225V54.5013C30.0625 53.6721 30.7172 53 31.5248 53Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5248 53H53.4908C54.2984 53 54.9531 53.6721 54.9531 54.5013V58.5225C54.9531 59.3517 54.2984 60.0238 53.4908 60.0238H31.5248C30.7172 60.0238 30.0625 59.3517 30.0625 58.5225V54.5013C30.0625 53.6721 30.7172 53 31.5248 53Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5329 58.516C55.5329 59.3451 54.8782 60.0172 54.0706 60.0172H36.7969H37.7294C38.537 60.0172 39.1917 59.3451 39.1917 58.516V54.5131C39.1917 53.6839 38.537 53.0117 37.7294 53.0117H36.7969H54.0706C54.8782 53.0117 55.5329 53.6839 55.5329 54.5131V58.516Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1953 58.5278C37.1953 59.3568 37.85 60.029 38.6577 60.029H62.819V59.237H44.3332C43.7948 59.237 43.3583 58.7889 43.3583 58.2361V54.9069C43.3583 54.3542 43.7948 53.9061 44.3332 53.9061H45.7532L38.8082 53.1683C37.9456 53.0767 37.1953 53.7714 37.1953 54.6616V58.5278Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4841 59.2468H46.6797H48.0996C48.6381 59.2468 49.0745 58.7987 49.0745 58.2459V54.9266C49.0745 54.3739 48.6381 53.9258 48.0996 53.9258H46.6797H54.4839H53.2189C52.6804 53.9258 52.244 54.3739 52.244 54.9266V58.2459C52.244 58.7987 52.6804 59.2468 53.2189 59.2468H54.4841Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1328 58.5378C31.1328 59.367 31.7876 60.0391 32.5952 60.0391L56.7562 60.0392V59.247H38.2707C37.7323 59.247 37.2958 58.7989 37.2958 58.2462V54.8016C37.2958 54.2489 37.7323 53.8008 38.2707 53.8008H39.6907H31.1328V58.5378Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9373 53.9228H28.4453V52.832H54.8335L55.9373 53.9228Z",
    fill: "#F3D6AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 46,
    width: 25,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5483 46.7578H52.5142C53.3218 46.7578 53.9766 47.43 53.9766 48.2591V52.2803C53.9766 53.1095 53.3218 53.7816 52.5142 53.7816H30.5483C29.7406 53.7816 29.0859 53.1095 29.0859 52.2803V48.2591C29.0859 47.43 29.7406 46.7578 30.5483 46.7578Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5483 46.7578H52.5142C53.3218 46.7578 53.9766 47.43 53.9766 48.2591V52.2803C53.9766 53.1095 53.3218 53.7816 52.5142 53.7816H30.5483C29.7406 53.7816 29.0859 53.1095 29.0859 52.2803V48.2591C29.0859 47.43 29.7406 46.7578 30.5483 46.7578Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5564 52.2737C54.5564 53.1028 53.9017 53.775 53.094 53.775H35.8203H36.7529C37.5605 53.775 38.2152 53.1028 38.2152 52.2737V48.2708C38.2152 47.4416 37.5605 46.7695 36.7529 46.7695H35.8203H53.094C53.9017 46.7695 54.5564 47.4416 54.5564 48.2708V52.2737Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1172 52.2933C33.1172 53.1225 33.7719 53.7947 34.5796 53.7947H58.7406V53.0026H40.2551C39.7167 53.0026 39.2802 52.5544 39.2802 52.0017V48.6725C39.2802 48.1198 39.7167 47.6717 40.2551 47.6717H41.6751L34.7301 46.9339C33.8675 46.8422 33.1172 47.5369 33.1172 48.4272V52.2933Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2419 53.1101H35.4375H36.8575C37.3959 53.1101 37.8324 52.662 37.8324 52.1092V48.7899C37.8324 48.2372 37.3959 47.7891 36.8575 47.7891H35.4375H43.2418H41.9767C41.4383 47.7891 41.0018 48.2372 41.0018 48.7899V52.1092C41.0018 52.662 41.4383 53.1101 41.9767 53.1101H43.2419Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6406 52.2956C28.6406 53.1248 29.2954 53.797 30.103 53.797H54.264V53.0049H35.7785C35.2401 53.0049 34.8036 52.5568 34.8036 52.004V48.5595C34.8036 48.0067 35.2401 47.5586 35.7785 47.5586H37.1985H28.6406V52.2956Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9607 47.6806H27.4688V46.5898H53.8569L54.9607 47.6806Z",
    fill: "#F3D6AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 33,
    width: 26,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8139 33.3594H48.7798C49.5875 33.3594 50.2422 34.0315 50.2422 34.8607V38.8819C50.2422 39.711 49.5875 40.3832 48.7798 40.3832H26.8139C26.0062 40.3832 25.3515 39.711 25.3515 38.8819V34.8607C25.3515 34.0315 26.0062 33.3594 26.8139 33.3594Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8139 33.3594H48.7798C49.5875 33.3594 50.2422 34.0315 50.2422 34.8607V38.8819C50.2422 39.711 49.5875 40.3832 48.7798 40.3832H26.8139C26.0062 40.3832 25.3515 39.711 25.3515 38.8819V34.8607C25.3515 34.0315 26.0062 33.3594 26.8139 33.3594Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.822 38.8753C50.822 39.7044 50.1673 40.3765 49.3596 40.3765H32.0859H33.0185C33.8261 40.3765 34.4808 39.7044 34.4808 38.8753V34.8724C34.4808 34.0432 33.8261 33.3711 33.0185 33.3711H32.0859H49.3596C50.1673 33.3711 50.822 34.0432 50.822 34.8724V38.8753Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3828 38.8949C29.3828 39.724 30.0376 40.3962 30.8452 40.3962H55.0063V39.6041H36.5207C35.9823 39.6041 35.5458 39.156 35.5458 38.6032V35.2741C35.5458 34.7214 35.9823 34.2732 36.5207 34.2732H37.9407L30.9957 33.5355C30.1331 33.4438 29.3828 34.1385 29.3828 35.0288V38.8949Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5076 39.7116H31.7031H33.1231C33.6616 39.7116 34.098 39.2636 34.098 38.7108V35.3915C34.098 34.8388 33.6616 34.3906 33.1231 34.3906H31.7031H39.5074H38.2424C37.7039 34.3906 37.2674 34.8388 37.2674 35.3915V38.7108C37.2674 39.2636 37.7039 39.7116 38.2424 39.7116H39.5076Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9062 38.8972C24.9062 39.7264 25.561 40.3985 26.3686 40.3985H50.5297V39.6065H32.0442C31.5057 39.6065 31.0693 39.1583 31.0693 38.6055V35.1611C31.0693 34.6083 31.5057 34.1602 32.0442 34.1602H33.4642H24.9062V38.8972Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2263 34.2822H23.7344V33.1914H50.1225L51.2263 34.2822Z",
    fill: "#F3D6AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 60,
    width: 26,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4311 60.0312H56.397C57.2047 60.0312 57.8594 60.7034 57.8594 61.5325V65.5538C57.8594 66.3829 57.2047 67.0551 56.397 67.0551H34.4311C33.6234 67.0551 32.9687 66.3829 32.9687 65.5538V61.5325C32.9687 60.7034 33.6234 60.0312 34.4311 60.0312Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4311 60.0312H56.397C57.2047 60.0312 57.8594 60.7034 57.8594 61.5325V65.5538C57.8594 66.3829 57.2047 67.0551 56.397 67.0551H34.4311C33.6234 67.0551 32.9687 66.3829 32.9687 65.5538V61.5325C32.9687 60.7034 33.6234 60.0312 34.4311 60.0312Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4392 65.5471C58.4392 66.3762 57.7845 67.0484 56.9768 67.0484H39.7031H40.6357C41.4433 67.0484 42.098 66.3762 42.098 65.5471V61.5442C42.098 60.7151 41.4433 60.043 40.6357 60.043H39.7031H56.9768C57.7845 60.043 58.4392 60.7151 58.4392 61.5442V65.5471Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4609 65.559C36.4609 66.3882 37.1156 67.0603 37.9233 67.0603L62.0842 67.0603V66.2682H43.5988C43.0604 66.2682 42.6239 65.8201 42.6239 65.2674V61.9382C42.6239 61.3854 43.0604 60.9373 43.5988 60.9373H45.0188L38.0738 60.1995C37.2112 60.1079 36.4609 60.8026 36.4609 61.6929V65.559Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9216 66.2077H44.1172H45.5371C46.0756 66.2077 46.512 65.7596 46.512 65.2069V61.8876C46.512 61.3348 46.0756 60.8867 45.5371 60.8867H44.1172H51.9214H50.6564C50.1179 60.8867 49.6815 61.3348 49.6815 61.8876V65.2069C49.6815 65.7596 50.1179 66.2077 50.6564 66.2077H51.9216Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5234 65.5691C32.5234 66.3982 33.1782 67.0703 33.9858 67.0703L58.1468 67.0704V66.2783H39.6614C39.123 66.2783 38.6865 65.8302 38.6865 65.2774V61.8329C38.6865 61.2802 39.123 60.832 39.6614 60.832H41.0813H32.5234V65.5691Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8435 60.9541H31.3516V59.8633H57.7397L58.8435 60.9541Z",
    fill: "#F3D6AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 40,
    width: 26,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1967 40.3828H55.1626C55.9703 40.3828 56.625 41.055 56.625 41.8841V45.9053C56.625 46.7345 55.9703 47.4066 55.1626 47.4066H33.1967C32.3891 47.4066 31.7343 46.7345 31.7343 45.9053V41.8841C31.7343 41.055 32.3891 40.3828 33.1967 40.3828Z",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1967 40.3828H55.1626C55.9703 40.3828 56.625 41.055 56.625 41.8841V45.9053C56.625 46.7345 55.9703 47.4066 55.1626 47.4066H33.1967C32.3891 47.4066 31.7343 46.7345 31.7343 45.9053V41.8841C31.7343 41.055 32.3891 40.3828 33.1967 40.3828Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2048 45.8987C57.2048 46.7279 56.5501 47.4 55.7425 47.4H38.4688H39.4013C40.2089 47.4 40.8636 46.7279 40.8636 45.8987V41.8958C40.8636 41.0667 40.2089 40.3945 39.4013 40.3945H38.4688H55.7425C56.5501 40.3945 57.2048 41.0667 57.2048 41.8958V45.8987Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2266 45.9105C35.2266 46.7397 35.8812 47.4118 36.6889 47.4118H60.8498V46.6197H42.3644C41.826 46.6197 41.3895 46.1716 41.3895 45.6189V42.2897C41.3895 41.737 41.826 41.2888 42.3644 41.2888H43.7844L36.8394 40.5511C35.9768 40.4594 35.2266 41.1541 35.2266 42.0444V45.9105Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6872 46.5592H42.8828H44.3027C44.8412 46.5592 45.2776 46.1112 45.2776 45.5584V42.2391C45.2776 41.6864 44.8412 41.2383 44.3027 41.2383H42.8828H50.687H49.422C48.8835 41.2383 48.4471 41.6864 48.4471 42.2391V45.5584C48.4471 46.1112 48.8835 46.5592 49.422 46.5592H50.6872Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2891 45.9206C31.2891 46.7498 31.9438 47.4219 32.7514 47.4219L56.9125 47.422V46.6298H38.427C37.8885 46.6298 37.4521 46.1818 37.4521 45.629V42.1844C37.4521 41.6317 37.8885 41.1836 38.427 41.1836H39.8469H31.2891V45.9206Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6091 41.3056H30.1172V40.2148H56.5054L57.6091 41.3056Z",
    fill: "#F3D6AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 26,
    width: 25,
    height: 8
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5483 26.3281H52.5142C53.3218 26.3281 53.9766 27.0003 53.9766 27.8294V31.8507C53.9766 32.6798 53.3218 33.3519 52.5142 33.3519H30.5483C29.7406 33.3519 29.0859 32.6798 29.0859 31.8507V27.8294C29.0859 27.0003 29.7406 26.3281 30.5483 26.3281Z",
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5483 26.3281H52.5142C53.3218 26.3281 53.9766 27.0003 53.9766 27.8294V31.8507C53.9766 32.6798 53.3218 33.3519 52.5142 33.3519H30.5483C29.7406 33.3519 29.0859 32.6798 29.0859 31.8507V27.8294C29.0859 27.0003 29.7406 26.3281 30.5483 26.3281Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5564 31.844C54.5564 32.6732 53.9017 33.3453 53.0941 33.3453H35.8203H36.7529C37.5605 33.3453 38.2152 32.6732 38.2152 31.844V27.8411C38.2152 27.012 37.5605 26.3398 36.7529 26.3398H35.8203H53.0941C53.9017 26.3398 54.5564 27.012 54.5564 27.8411V31.844Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5781 31.8558C32.5781 32.685 33.2328 33.3571 34.0405 33.3572H58.2014V32.565H39.716C39.1776 32.565 38.7411 32.117 38.7411 31.5642V28.235C38.7411 27.6823 39.1776 27.2342 39.716 27.2342H41.136L34.191 26.4964C33.3284 26.4047 32.5781 27.0994 32.5781 27.9897V31.8558Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0388 32.5045H40.2344H41.6543C42.1927 32.5045 42.6292 32.0565 42.6292 31.5037V28.1844C42.6292 27.6317 42.1927 27.1836 41.6543 27.1836H40.2344H48.0386H46.7735C46.2351 27.1836 45.7986 27.6317 45.7986 28.1844V31.5037C45.7986 32.0565 46.2351 32.5045 46.7735 32.5045H48.0388Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6406 31.8659C28.6406 32.6951 29.2954 33.3672 30.103 33.3672L54.264 33.3673V32.5751H35.7785C35.2401 32.5751 34.8036 32.1271 34.8036 31.5743V28.1298C34.8036 27.577 35.2401 27.1289 35.7785 27.1289H37.1985H28.6406V31.8659Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9607 27.2509H27.4688V26.1602H53.8569L54.9607 27.2509Z",
    fill: "#F3D6AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 67,
    width: 26,
    height: 8
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3139 67.0547H51.2798C52.0875 67.0547 52.7422 67.7268 52.7422 68.556V72.5772C52.7422 73.4063 52.0875 74.0785 51.2798 74.0785H29.3139C28.5062 74.0785 27.8515 73.4063 27.8515 72.5772V68.556C27.8515 67.7268 28.5062 67.0547 29.3139 67.0547Z",
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3139 67.0547H51.2798C52.0875 67.0547 52.7422 67.7268 52.7422 68.556V72.5772C52.7422 73.4063 52.0875 74.0785 51.2798 74.0785H29.3139C28.5062 74.0785 27.8515 73.4063 27.8515 72.5772V68.556C27.8515 67.7268 28.5062 67.0547 29.3139 67.0547Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.322 72.5706C53.322 73.3997 52.6673 74.0719 51.8596 74.0719H34.5859H35.5185C36.3261 74.0719 36.9808 73.3997 36.9808 72.5706V68.5677C36.9808 67.7385 36.3261 67.0664 35.5185 67.0664H34.5859H51.8596C52.6673 67.0664 53.322 67.7385 53.322 68.5677V72.5706Z",
    fill: "#F7993B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8828 72.5903C31.8828 73.4193 32.5376 74.0915 33.3452 74.0915H57.5063V73.2995H39.0207C38.4823 73.2995 38.0458 72.8513 38.0458 72.2986V68.9694C38.0458 68.4167 38.4823 67.9686 39.0207 67.9686H40.4407L33.4957 67.2308C32.6331 67.1392 31.8828 67.8339 31.8828 68.7241V72.5903Z",
    fill: "#D1674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2263 73.2312H38.4219H39.8419C40.3803 73.2312 40.8168 72.7831 40.8168 72.2303V68.911C40.8168 68.3583 40.3803 67.9102 39.8419 67.9102H38.4219H46.2261H44.9611C44.4227 67.9102 43.9862 68.3583 43.9862 68.911V72.2303C43.9862 72.7831 44.4227 73.2312 44.9611 73.2312H46.2263Z",
    fill: "#F3D6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4062 72.5925C27.4062 73.4216 28.0609 74.0938 28.8686 74.0938H53.0296V73.3017H34.5442C34.0057 73.3017 33.5693 72.8536 33.5693 72.3009V68.8563C33.5693 68.3035 34.0057 67.8555 34.5442 67.8555H35.9641H27.4062V72.5925Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7263 67.9775H26.2344V66.8867H52.6225L53.7263 67.9775Z",
    fill: "#F3D6AB"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5987 72.6697C21.5442 73.9858 25.1386 74.5226 28.5679 72.1808C34.0592 68.4687 36.4656 60.4772 33.9552 54.2969C32.5111 50.7646 28.2102 48.48 24.7953 47.2344L15.7812 71.985L17.5987 72.6697Z",
    fill: "#7E3E30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_14304_101293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 47,
    width: 20,
    height: 27
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5987 72.6775C21.5441 73.9936 25.1385 74.5304 28.5678 72.1886C34.0592 68.4765 36.4656 60.485 33.9552 54.3047C32.5111 50.7724 28.2101 48.4878 24.7953 47.2422L15.7812 71.9929L17.5987 72.6775Z",
    fill: "#7E3E30"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_14304_101293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6635 57.4983C17.6688 51.122 20.8101 44.3842 26.6798 42.4489C32.5495 40.5136 38.9248 44.1137 40.9195 50.49C42.9142 56.8662 39.7729 63.604 33.9032 65.5393C28.0335 67.4746 21.6582 63.8745 19.6635 57.4983Z",
    fill: "#D1674F"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4973 70.6263C19.006 74.3385 12.4962 72.3326 10.0035 66.1364C7.51074 59.9401 9.93489 51.9327 15.4418 48.2387C20.9309 44.5608 27.4074 46.5644 29.9179 52.7447C32.4284 58.925 30.0219 66.9165 24.5306 70.6286L24.4973 70.6263Z",
    fill: "#FFC165"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8826 67.9384C20.9249 69.2472 18.776 69.6331 16.8421 69.0206C14.9416 68.4103 13.4337 66.8998 12.5673 64.7804C11.6453 62.4856 11.5712 59.7507 12.3763 57.1271C13.1659 54.4853 14.7481 52.2581 16.8102 50.8877C18.7679 49.5788 20.9168 49.193 22.8662 49.8237C24.7667 50.4339 26.259 51.9263 27.141 54.0639C28.063 56.3587 28.1393 59.0594 27.3497 61.7012C26.5602 64.3431 24.9779 66.5703 22.9315 67.9589L22.8826 67.9384Z",
    fill: "#FFE0B2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2837 63.8055L17.0703 59.3567L18.3871 59.8624C19.6561 60.2853 21.1627 60.0458 21.8056 58.4703C22.1173 57.6983 22.6298 55.8626 20.689 55.1172",
    stroke: "#F7993B",
    strokeWidth: 1.90812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6797 56.6328L23.2699 58.7799",
    stroke: "#F7993B",
    strokeWidth: 1.90812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 54.3555L24.3471 56.5198",
    stroke: "#F7993B",
    strokeWidth: 1.90812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M45.1372 70.2798C40.8933 70.2798 37.4531 66.8531 37.4531 62.6264V22.13C37.4531 17.903 40.8936 14.4766 45.1372 14.4766C49.3812 14.4766 52.8213 17.903 52.8213 22.13V62.6264C52.8213 66.8531 49.3812 70.2798 45.1372 70.2798Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5375 29.4815C57.8324 25.3057 54.4965 22.0299 50.2812 21.3948C54.4965 20.7602 57.832 17.4843 58.5375 13.3086C59.2426 17.4843 62.5785 20.7605 66.7937 21.3948C62.5785 22.0299 59.2426 25.3054 58.5375 29.4815Z",
    fill: "#1C359F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34551 36.8785C7.01167 34.9016 5.4328 33.351 3.4375 33.0506C5.4328 32.7501 7.01202 31.1995 7.34551 29.2227C7.67934 31.1992 9.25822 32.7501 11.2539 33.0506C9.25822 33.3514 7.67934 34.902 7.34551 36.8785Z",
    fill: "#1C359F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9852 52.9607C49.8183 51.9723 49.0289 51.1972 48.0312 51.0466C49.0289 50.8964 49.8183 50.1209 49.9852 49.1328C50.1522 50.1212 50.9416 50.8967 51.9393 51.0466C50.9416 51.1972 50.1518 51.9726 49.9852 52.9607Z",
    fill: "#1C359F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95401 68.617C1.78709 67.6285 0.997649 66.8534 0 66.7028C0.997649 66.5526 1.78709 65.7771 1.95401 64.7891C2.12092 65.7775 2.91036 66.5526 3.90801 66.7028C2.91036 66.8534 2.12092 67.6289 1.95401 68.617Z",
    fill: "#1C359F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2118 16.2967C51.0449 15.3082 50.2555 14.5331 49.2578 14.3825C50.2555 14.2323 51.0449 13.4568 51.2118 12.4688C51.3787 13.4572 52.1682 14.2323 53.1658 14.3825C52.1682 14.5331 51.3787 15.3082 51.2118 16.2967Z",
    fill: "#1C359F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14304_101293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.0008,
    height: 49.0004,
    fill: "white",
    transform: "translate(7.86719 25.5938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSip);
export default __webpack_public_path__ + "static/media/manage-sip.91bffb3ddc6753049e1e0ac0f9c9bd51.svg";
export { ForwardRef as ReactComponent };